import * as React from 'react';

export const useHeight = () => {
  const [height, setHeight] = React.useState<number>(0);
  const ref: any = React.useRef(null);

  const setRef: any = React.useCallback((node: any) => {
    if (node) {
      setTimeout(() => {
        setHeight(node.clientHeight);
      }, 50);
    }
    ref.current = node;
  }, []);

  const updateHeight = () => {
    setHeight(ref.current.clientHeight);
  };

  React.useEffect(() => {
    window.addEventListener('resize', updateHeight, false);
    return () => {
      window.removeEventListener('resize', updateHeight, false);
    };
  });
  return [setRef, height];
};
